export default "__VITE_ASSET__CYy6UyuR__"